import {BaseLoginProvider} from '../entities/base-login-provider';
import {SocialUser} from '../entities/user';
import {LoginOpt} from '../auth-service-social.service';

declare let gapi: any;

export class GoogleLoginProvider extends BaseLoginProvider {

    public static readonly PROVIDER_ID: string = 'GOOGLE';

    protected auth2: any;

    constructor(private clientId: string, private opt: LoginOpt = {scope: 'email'}) {
        super();
    }

    initialize(): Promise<void> {
        return new Promise((resolve, reject) => {
            BaseLoginProvider.loadScript(GoogleLoginProvider.PROVIDER_ID,
                'https://apis.google.com/js/platform.js',
                () => {
                    gapi.load('auth2', () => {
                        this.auth2 = gapi.auth2.init({
                            ...this.opt,
                            client_id: this.clientId
                        });

                        this.auth2.then(() => {
                            this._readyState.next(true);
                            // @ts-ignore
                            resolve('ok');
                        }).catch((err: any) => {
                            this.messageError = err;
                            reject(err);
                        });
                    });
                });
        });
    }

    /**  https://developers.google.com/identity/sign-in/web/**/
    getLoginStatus(): Promise<SocialUser> {
        return new Promise((resolve) => {
            this.onReady().then(() => {
                if (this.auth2.isSignedIn.get()) {
                    const user: SocialUser = new SocialUser();
                    const profile = this.auth2.currentUser.get().getBasicProfile();
                    const token = this.auth2.currentUser.get().getAuthResponse(true).access_token;
                    const backendToken = this.auth2.currentUser.get().getAuthResponse(true).id_token;

                    user.id = profile.getId();
                    user.name = profile.getName();
                    user.email = profile.getEmail();
                    user.photoUrl = profile.getImageUrl();
                    user.firstName = profile.getGivenName();
                    user.lastName = profile.getFamilyName();
                    user.authToken = token;
                    user.idToken = backendToken;
                    resolve(user);
                }
            });
        });
    }

    signIn(opt?: LoginOpt): Promise<SocialUser> {
        return new Promise((resolve, reject) => {
            this.onReady().then(() => {
                const promise = this.auth2.signIn(opt);

                promise.then(() => {
                    const user: SocialUser = new SocialUser();
                    const profile = this.auth2.currentUser.get().getBasicProfile();
                    const token = this.auth2.currentUser.get().getAuthResponse(true).access_token;
                    const backendToken = this.auth2.currentUser.get().getAuthResponse(true).id_token;

                    user.id = profile.getId();
                    user.name = profile.getName();
                    user.email = profile.getEmail();
                    user.photoUrl = profile.getImageUrl();
                    user.firstName = profile.getGivenName();
                    user.lastName = profile.getFamilyName();
                    user.authToken = token;
                    user.idToken = backendToken;
                    resolve(user);
                }, () => {
                    reject('User cancelled login or did not fully authorize.');
                }).catch((err: any) => {
                    reject(err);
                });
            }).catch((err: any) => {
                reject(err);
            });
        });
    }

    signOut(revoke?: boolean): Promise<any> {
        return new Promise((resolve, reject) => {
            this.onReady().then(() => {
                let signOutPromise;
                if (revoke) {
                    signOutPromise = this.auth2.disconnect();
                } else {
                    signOutPromise = this.auth2.signOut();
                }

                signOutPromise.then((err: any) => {
                    if (err) {
                        reject(err);
                    } else {
                        resolve("ok");
                    }
                }).catch((err: any) => {
                    reject(err);
                });
            });
        });
    }
}
